import { manageJss } from "./manage-jss";
export default manageJss;
export { DesignSystemProvider, } from "./design-system-provider";
export { stylesheetRegistry, 
/**
 * @deprecated
 * use JSSManager.jss to access the JSS instance
 */
jss, } from "./jss";
export { Consumer as DesignSystemConsumer } from "./context";
export { JSSManager, } from "./jss-manager";
export * from "./design-system-provider";
export * from "@fast/fast-jss-manager";
